class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

        this.isMouseDown = false;

        document.addEventListener('mouseup', (e) => this.processBgRemoval(e, false));
        document.addEventListener('mousedown', (e) => this.processBgRemoval(e, true));
    }
    processBgRemoval(e, isMouseDown) {
        requestAnimationFrame(() => {
            let closestDetails = e.target.closest('details')
            this.isMouseDown = isMouseDown;
            if(!this.anyDetailsAreOpen() && closestDetails != this.mainDetailsToggle || closestDetails == null) {
                this.closest('.header__inline-menu').classList.remove('header--megamenu-open')
            }
        })
    }
    onFocusOut() {
        requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }
    onToggle() {
        if (this.anyDetailsAreOpen()) {
            this.closest('.header__inline-menu').classList.add('header--megamenu-open')
        }
    }
    anyDetailsAreOpen() {
        return !!this.closest('.header__inline-menu').querySelector('details[open]')
    }
    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        if(!this.anyDetailsAreOpen() && !this.isMouseDown) {
            this.closest('.header__inline-menu').classList.remove('header--megamenu-open')
        }
    }
}
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super();
        this.header = document.querySelector('.header-wrapper');
    }
    onToggle() {
        if (!this.header) return;

        this.header.preventHide = this.mainDetailsToggle.open;
        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
}
customElements.define('header-menu', HeaderMenu);
